export default "__VITE_ASSET__Ck9BOKoV__"